import { i18n } from '@core/config/i18n.installer.js'
import { apiClient, serviceEndpoints } from '@shared/services/http/http.service.js'
import { clearPendingSubmission, peekPendingSubmission } from '@shared/utils/pending-submission.utils.js'
import ToastEventBus from 'primevue/toasteventbus'
import { watch } from 'vue'

const FEEDBACK_TOAST_LIFE_MS = 6000

let started = false
let stopUserWatch = null

function resolveServiceFromBaseUrl(baseURL) {
  const match = Object.entries(serviceEndpoints).find(([, path]) => baseURL?.endsWith(path))
  return match?.[0] ?? null
}

function emitFeedback(severity, messageKey) {
  ToastEventBus.emit('add', {
    severity,
    summary: i18n.global.t(`session.pending-submission.${messageKey}`),
    life: FEEDBACK_TOAST_LIFE_MS,
  })
}

async function resendSubmission(entry, close) {
  try {
    const service = resolveServiceFromBaseUrl(entry.baseURL)
    if (!service)
      throw new Error('Unknown service for pending submission')

    const client = apiClient(service)
    const method = entry.method.toLowerCase()

    if (method === 'delete')
      await client.delete(entry.url)
    else
      await client[method](entry.url, JSON.parse(entry.data))

    emitFeedback('success', 'resent-success')
  }
  catch {
    emitFeedback('error', 'resent-error')
  }
  finally {
    close()
  }
}

function offerPendingSubmission(b2cId) {
  const entry = peekPendingSubmission({ b2cId })
  if (!entry)
    return

  clearPendingSubmission()

  ToastEventBus.emit('add', {
    severity: 'info',
    summary: i18n.global.t('session.pending-submission.title'),
    detail: i18n.global.t('session.pending-submission.detail'),
    action: {
      label: i18n.global.t('session.pending-submission.action'),
      onClick: close => resendSubmission(entry, close),
    },
  })
}

export function startPendingSubmissionOffer({ authStore }) {
  if (started)
    return
  started = true

  stopUserWatch = watch(
    () => authStore.userData?.b2cId ?? null,
    (b2cId) => {
      if (b2cId)
        offerPendingSubmission(b2cId)
    },
    { immediate: true },
  )
}

export function resetPendingSubmissionOfferForTests() {
  started = false
  stopUserWatch?.()
  stopUserWatch = null
}
